<template>
  <ClearLayout>
    <ContainerWrapper class="LoanDataPage">
      <NavBar
        :extended="true"
        @back="$router.back()"
        @close="$router.push('/home')"
      />
      <ContentContainerWrapper>
        <FgtsForm :data="form" @submit="submit($event)" />
      </ContentContainerWrapper>
    </ContainerWrapper>
  </ClearLayout>
</template>

<script>
import ContentContainerWrapper from '@/components/ui/newComponents/ContentContainerWrapper.vue'
import NavBar from '@/aasgard/components/navigation/NavBar.vue'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import ClearLayout from '@/layouts/ClearLayout.vue'
import { defineAsyncComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'
const FgtsForm = defineAsyncComponent(
  () => import('@/components/forms/loans/fgts/FgtsForm.vue'),
)
export default {
  name: 'FgtsFormPage',
  components: {
    FgtsForm,
    ClearLayout,
    ContentContainerWrapper,
    NavBar,
    ContainerWrapper,
  },
  data() {
    return {
      form: {
        fgts_balance: 50,
      },
    }
  },
  computed: {
    ...mapGetters({
      gtFgtsLatestSimulationRequest:
        'products/loans/fgts/gtFgtsLatestSimulationRequest',
    }),
  },
  mounted() {
    if (this.gtFgtsLatestSimulationRequest) {
      this.form = this.gtFgtsLatestSimulationRequest
    }
  },
  methods: {
    ...mapActions({
      actSetFgtsLatestSimulationRequest:
        'products/loans/fgts/actSetFgtsLatestSimulationRequest',
    }),
    submit(data) {
      this.actSetFgtsLatestSimulationRequest(data)
      this.$router.push({
        path: '/forms/emprestimo/fgts/simular',
        query: this.$route?.query || {},
      })
    },
  },
}
</script>
